import * as React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { IEmptyProps } from 'src/constants';
import { TR } from 'src/TextRes';
import {
    ApiCourseProvidersLoadmine,
    ApiCourseProvidersRemoveLecturer,
    ApiCourseProvidersSaveLecturer,
    CoursesProviderLoadMineResult,
    CoursesProviderRemoveLecturerResult,
    CoursesProviderSaveLecturerResult,
    Lecturer,
    ServerResponse,
    UploadImage,
    ValidationError,
} from '../../api';
import CPHeaderLoggedIn from '../../components/cpHeaderLoggedIn/CPHeaderLoggedIn';
import CPLecturerList from '../../components/cpLecturerList/CPLecturerList';
import Footer from '../../components/footer/Footer';
import NetworkOverlay from '../../components/networkOverlay/NetworkOverlay';

interface IState {
    currentEditLecturerID: number | undefined;
    currentDeleteLecturerID: number | undefined;
    editValue: Lecturer;
    uploadImage?: UploadImage;
    errors: string[];
    lecturerList: Lecturer[];
    loading: boolean;
    matchList: string[];
    modalOpen: boolean;
    modalState: SelectionMethod;
    newLecturer: Lecturer;
    serverResponse?: ServerResponse;
    profileURLError: boolean;
}

export enum SelectionMethod {
    Delete,
    Edit,
    None,
}

export default class CPAllLecturers extends React.PureComponent<IEmptyProps, IState> {
    constructor(props: IEmptyProps) {
        super(props);
        this.state = {
            currentDeleteLecturerID: undefined,
            currentEditLecturerID: undefined,
            editValue: {
                Description: '',
                FirstName: '',
                ID: 0,
                Image: undefined,
                LastName: '',
                ProfileURL: '',
                Salutation: 'Frau',
                Title: 'Professor',
            },
            errors: [],
            lecturerList: [],
            loading: true,
            matchList: [],
            modalOpen: false,
            modalState: SelectionMethod.None,
            newLecturer: {
                Description: '',
                FirstName: '',
                ID: 0,
                Image: undefined,
                LastName: '',
                ProfileURL: '',
                Salutation: '',
                Title: '',
            },
            profileURLError: false,
            serverResponse: undefined,
            uploadImage: undefined,
        };
    }

    public componentDidMount() {
        ApiCourseProvidersLoadmine((cpsr: ServerResponse & { Data?: CoursesProviderLoadMineResult }) => {
            if (cpsr.OK && cpsr.Data) {
                this.setState(
                    {
                        lecturerList: cpsr.Data.CourseProviderEdit.Lecturers,
                        loading: false,
                    },
                    () => {
                        if (this.state.lecturerList.length === 0) {
                            const lecturerList: Lecturer[] = [];
                            lecturerList.push(this.state.newLecturer);
                            this.setState(
                                {
                                    lecturerList,
                                },
                                () => {
                                    this.selectEntry(this.state.lecturerList[0].ID, SelectionMethod.Edit);
                                }
                            );
                        }
                    }
                );
            } else {
                this.setState({
                    serverResponse: cpsr,
                });
            }
        });
    }

    public render() {
        return (
            <NetworkOverlay loading={this.state.loading} serverResponse={this.state.serverResponse}>
                <CPHeaderLoggedIn />
                <CPLecturerList
                    addNewRecord={this.addNewRecord}
                    cancelHandler={this.cancelHandler}
                    changeHandler={this.changeHandler}
                    changeImage={this.changeImage}
                    imageData={
                        this.state.uploadImage && !this.state.uploadImage.Delete
                            ? this.state.uploadImage.ImageData
                            : undefined
                    }
                    imageDelete={this.state.uploadImage ? this.state.uploadImage.Delete : false}
                    editItemID={this.state.currentEditLecturerID}
                    editValue={this.state.editValue}
                    errorClass={this.errorClass}
                    errors={this.state.errors}
                    serverResponse={this.state.serverResponse}
                    lecturers={this.state.lecturerList}
                    saveHandler={this.saveHandler}
                    selectEntry={this.selectEntry}
                />
                <Modal isOpen={this.state.modalOpen}>
                    <ModalHeader>{TR.cPAllLecturers_delete_entry}</ModalHeader>
                    <ModalBody>{TR.cPAllLecturers_confirm_delete}</ModalBody>
                    <ModalFooter>
                        <Button
                            color="primary"
                            onClick={() => {
                                this.deleteHandler(this.state.currentDeleteLecturerID!);
                            }}
                        >
                            {TR.cPAllLecturers_delete}
                        </Button>{' '}
                        <Button color="secondary" onClick={() => this.toggleModal(SelectionMethod.None)}>
                            {TR.cPAllLecturers_cancel}
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={!!this.state.matchList && this.state.matchList.length > 0}>
                    <ModalHeader>{TR.cPAllLecturers_cannot_delete}</ModalHeader>
                    <ModalBody>
                        <div className="col-md-12">{TR.cPAllLecturers_cannot_delete_lecturer}</div>
                        <br />
                        {!!this.state.matchList &&
                            this.state.matchList.map((entry, i) => (
                                <div key={i} className="col-md-12">
                                    <label style={{ color: 'green' }}>{'->' + entry}</label>
                                </div>
                            ))}
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            onClick={() => {
                                this.setState({ matchList: [] });
                            }}
                        >
                            {TR.cPAllLecturers_ok}
                        </Button>
                    </ModalFooter>
                </Modal>
                <Footer />
            </NetworkOverlay>
        );
    }

    private addNewRecord = () => {
        const lecturerList: Lecturer[] = this.state.lecturerList;
        const newLecturer: Lecturer = this.state.newLecturer;

        lecturerList.push(newLecturer);

        this.setState({ lecturerList }, () => this.selectEntry(0, SelectionMethod.Edit));
    };

    private changeImage = (image: UploadImage) => {
        this.setState({ uploadImage: image });
    };

    private deleteHandler = (entryId: number) => {
        this.setState({
            loading: true,
            modalOpen: false,
            modalState: SelectionMethod.None,
        });
        ApiCourseProvidersRemoveLecturer(
            { EntryID: entryId },
            (cpsr: ServerResponse & { Data?: CoursesProviderRemoveLecturerResult }) => {
                if (cpsr.OK && cpsr.Data) {
                    this.setState(
                        {
                            lecturerList: cpsr.Data.Lecturers,
                            loading: false,
                            matchList: cpsr.Data.MatchedList,
                            uploadImage: undefined,
                        },
                        () => {
                            if (this.state.lecturerList.length === 0) {
                                const lecturerList: Lecturer[] = [];
                                lecturerList.push(this.state.newLecturer);
                                this.setState(
                                    {
                                        lecturerList,
                                    },
                                    () => {
                                        this.selectEntry(this.state.lecturerList[0].ID, SelectionMethod.Edit);
                                    }
                                );
                            }
                        }
                    );
                } else {
                    this.setState({
                        serverResponse: cpsr,
                    });
                }
            }
        );
    };

    private getLecturerById = (entryId: number) => {
        return this.state.lecturerList.filter((lec) => lec.ID === entryId)[0];
    };

    private selectEntry = (entryId: number, selectionMethod: SelectionMethod) => {
        if (selectionMethod === SelectionMethod.Delete) {
            this.setState({ currentDeleteLecturerID: entryId, modalOpen: true, modalState: selectionMethod });
        } else if (selectionMethod === SelectionMethod.Edit) {
            this.setState({ currentEditLecturerID: entryId, editValue: this.getLecturerById(entryId) });
        }
    };

    private saveHandler = () => {
        this.setState(
            {
                loading: true,
                profileURLError:
                    this.state.editValue.ProfileURL !== '' &&
                    !(
                        this.state.editValue.ProfileURL.substr(0, 7) === 'http://' ||
                        this.state.editValue.ProfileURL.substr(0, 8) === 'https://'
                    ),
            },
            () => {
                const editValue = { ...this.state.editValue };
                if (this.state.profileURLError) {
                    editValue.ProfileURL = 'http://'.concat(editValue.ProfileURL);
                }
                this.setState(
                    (prevState: IState): IState => {
                        return { ...prevState, editValue };
                    },
                    () => this.saveLecturer()
                );
            }
        );
    };

    private saveLecturer = () => {
        // save image

        ApiCourseProvidersSaveLecturer(
            {
                Description: this.state.editValue.Description,
                FirstName: this.state.editValue.FirstName,
                ID: this.state.editValue.ID,
                Image: this.state.editValue.Image,
                LastName: this.state.editValue.LastName,
                ProfileURL: this.state.editValue.ProfileURL,
                Salutation: this.state.editValue.Salutation,
                Title: this.state.editValue.Title,
                UploadImage: this.state.uploadImage,
            },
            (sr: ServerResponse & { Data?: CoursesProviderSaveLecturerResult }) => {
                if (sr.OK && sr.Data) {
                    this.setState({
                        currentEditLecturerID: undefined,
                        editValue: this.state.newLecturer,
                        lecturerList: sr.Data.Lecturers,
                        loading: false,
                        serverResponse: undefined,
                    });
                } else if (!sr.OK && sr.Error === 'validation_error') {
                    this.setState({
                        loading: false,
                        serverResponse: sr,
                    });
                } else {
                    this.setState({
                        serverResponse: sr,
                    });
                }
            }
        );
    };

    private errorClass = (fieldname: string) => {
        if (this.state.serverResponse && this.state.serverResponse.Errors) {
            const errorsForThisField = this.state.serverResponse.Errors.filter(
                (error: ValidationError) => error.Parameter.toLowerCase() === fieldname.toLowerCase()
            );
            return errorsForThisField.length > 0 ? 'error' : '';
        }
        return '';
    };

    private cancelHandler = () => {
        const lecturerToChange: Lecturer = this.getLecturerById(this.state.currentEditLecturerID!);
        if (lecturerToChange.FirstName === '' || lecturerToChange.LastName === '') {
            if (this.state.lecturerList.length > 1) {
                const lecturerList: Lecturer[] = this.state.lecturerList;
                lecturerList.pop();
                this.setState({
                    lecturerList,
                });
            } else {
                return;
            }
        }
        this.setState({
            currentEditLecturerID: undefined,
            errors: [],
            serverResponse: undefined,
            uploadImage: undefined,
        });
    };

    private changeHandler = (value: string, field: string) => {
        const editValue: Lecturer = { ...this.state.editValue };
        // @ts-ignore
        editValue[field] = value;
        this.setState({
            editValue,
        });
    };

    private toggleModal = (modalState: SelectionMethod) => {
        this.setState({
            modalOpen: !this.state.modalOpen,
            modalState,
        });
    };
}



// WEBPACK FOOTER //
// ./src/views/cPAllLecturers/CPAllLecturers.tsx